"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getImageExtension = function (options) {
    var _a, _b;
    var src = options.src, imageDetails = options.imageDetails, filename = options.filename;
    var actualFileName = src || filename || (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.filename);
    if (!actualFileName) {
        return null;
    }
    return (_b = (_a = actualFileName.split('?')[0].match(/\.(?<extension>\w+)$/)) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.extension;
};
exports.default = getImageExtension;
//# sourceMappingURL=getImageExtension.js.map